import createIcon from '../../createIcon';

/**
 * @component @name ScreenLockPortrait
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTZIMTRDMTQuNTUgMTYgMTUgMTUuNTUgMTUgMTVWMTJDMTUgMTEuNDUgMTQuNTUgMTEgMTQgMTFWMTBDMTQgOC44OSAxMy4xIDggMTIgOEMxMC44OSA4IDEwIDguOSAxMCAxMFYxMUM5LjQ1IDExIDkgMTEuNDUgOSAxMlYxNUM5IDE1LjU1IDkuNDUgMTYgMTAgMTZaTTEwLjggMTBDMTAuOCA5LjM0IDExLjM0IDguOCAxMiA4LjhDMTIuNjYgOC44IDEzLjIgOS4zNCAxMy4yIDEwVjExSDEwLjhWMTBaTTE3IDFIN0M1LjkgMSA1IDEuOSA1IDNWMjFDNSAyMi4xIDUuOSAyMyA3IDIzSDE3QzE4LjEgMjMgMTkgMjIuMSAxOSAyMVYzQzE5IDEuOSAxOC4xIDEgMTcgMVpNMTcgMTlIN1Y1SDE3VjE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScreenLockPortrait = createIcon('ScreenLockPortrait', [
  [
    'path',
    {
      d: 'M10 16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11V10C14 8.89 13.1 8 12 8C10.89 8 10 8.9 10 10V11C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16ZM10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10V11H10.8V10ZM17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19Z',
      key: '8wtcsr',
    },
  ],
]);

export default ScreenLockPortrait;
